import { create } from 'zustand';

export interface IOnboardingStoreType {
  hideSidebar: boolean;
  updateSidebar: (x: boolean) => void;
}

export const useOnboardingStore = create<IOnboardingStoreType>((set) => ({
  hideSidebar: false,
  updateSidebar: (x: boolean) => set(() => ({ hideSidebar: x })),
}));

export default useOnboardingStore;
